import React, { FC, useEffect } from 'react';
import { Flex, TextV2, useDisclosure } from '@withjoy/joykit';
import { useSmartAppBannerProvider } from '@shared/components';
import { pxToRem } from '@withjoy/joykit/theme';
import { useGeneralInfoBannerProvider } from './GeneralInfoBanner.Provider';
import { useEventUserRole } from '@shared/components/AuthProvider';

export const GeneralInfoBanner: FC = () => {
  const { isOpen, onOpen } = useDisclosure();

  const { isAdmin } = useEventUserRole();

  const { isGeneralInfoBannerVisible, calculateGeneralInfoBannerHeight, bannerProps } = useGeneralInfoBannerProvider();
  const { smartAppBannerHeight } = useSmartAppBannerProvider();

  useEffect(() => {
    if (isGeneralInfoBannerVisible) {
      onOpen();
    }
  }, [isGeneralInfoBannerVisible, onOpen]);

  useEffect(() => {
    calculateGeneralInfoBannerHeight();
  }, [isOpen, calculateGeneralInfoBannerHeight]);

  if (!isAdmin) {
    return null;
  }

  return (
    <Flex
      id="general-info-banner"
      display={isOpen ? 'flex' : 'none'}
      position="fixed"
      zIndex={1300}
      top={smartAppBannerHeight || 0}
      padding={pxToRem(10)}
      gap={pxToRem(10)}
      alignItems="center"
      backgroundColor="mono12"
      justifyContent="center"
      width="100%"
    >
      {bannerProps.icon}
      <TextV2 typographyVariant="label1" color="white">
        {bannerProps.content}
      </TextV2>
    </Flex>
  );
};

GeneralInfoBanner.displayName = 'GeneralInfoBanner';
